import type { AuthProvider } from "@refinedev/core";
import { useAuth } from "react-oidc-context";

let cachedAuth: ReturnType<typeof useAuth>;

export const setOidcAuthContext = (auth: ReturnType<typeof useAuth>) => {
  cachedAuth = auth;
};

export const authProvider: AuthProvider = {
  login: async () => {
    if (!cachedAuth) throw new Error("OIDC auth context not set");
    await cachedAuth.signinRedirect();
    return {
      success: true,
      redirectTo: "/",
    };
  },

  logout: async () => {
    void cachedAuth.signoutRedirect({
      extraQueryParams: {
        client_id: import.meta.env
          .VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_CLIENT_ID,
        redirect_uri: import.meta.env
          .VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_REDIRECT_URI,
        response_type: "code",
      },
    });

    return {
      success: true,
    };
  },

  check: async () => {
    if (!cachedAuth) throw new Error("OIDC auth context not set");

    if (cachedAuth.isAuthenticated) {
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },

  getIdentity: async () => {
    if (!cachedAuth?.user?.profile) return null;

    return {
      id: cachedAuth.user.profile.sub,
      name: cachedAuth.user.profile.name || cachedAuth.user.profile.email,
      avatar: "",
      jwt: cachedAuth.user.access_token || "",
    };
  },

  getPermissions: async () => null,

  onError: async (error) => {
    console.error("OIDC auth error:", error);
    return { error };
  },
};
